import { FormControl, InputLabel, Tooltip } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form"
import { SolicCompartilhamentoSearchField } from "../../../../components/Searchfields/SolicitacaoCompartilhamento";
import styles from "../Cadastro.module.css";
import { HelperText } from "../../../../components/Errors/HelperText";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import { useEffect, useState } from "react";

const Geral = ({ situacao }) => {
  const { control, getValues, formState: { errors } } = useFormContext();
  const [editavelSituacao, setEditavelSituacao] = useState(false);
  const editavel = !getValues("Id") ? true : false;

  useEffect(() => {
    const situacoesEditaveis = [0, 2];

    setEditavelSituacao(!situacoesEditaveis.includes(situacao));
  }, [situacao]);

  return (
    <div>
      <div className={styles['input-container']}>
        <Controller
          name="SolicitacaoCompartilhamento"
          control={control}
          render={({ field }) => (
            <FormControl variant="outlined" className={styles['campos-g']} style={{ zIndex: 2 }}>
              <InputLabel htmlFor="fiscalizacao-solic-comp" shrink sx={{ color: "#B8B8B8" }}>Solicitação de compartilhamento</InputLabel>
              <SolicCompartilhamentoSearchField
                id="fiscalizacao-solic-comp"
                field={field}
                disabled={editavel}
                className={`${errors?.SolicitacaoCompartilhamento ? styles.campoComValorErrado : ""}`}
              />
              {errors?.SolicitacaoCompartilhamento && (
                <HelperText text="Este campo é obrigatório" />
              )}
            </FormControl>
          )}
        />
      </div>

      <div className={styles.inputContainerColumn}>
        <FormControl variant="outlined" style={{ marginTop: "20px", marginLeft: "60px" }} className={styles['campos-p']}>
          <InputLabel shrink style={{ color: "#B8B8B8" }} >
            Data início instalação
          </InputLabel>
          <Controller
            name="DataInicioInstalacao"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                <DatePicker
                  fullWidth
                  inputFormat="dd/MM/yyyy"
                  {...field}
                  disabled={editavelSituacao}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <>
                      <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#fff" }} className={`${errors?.DataInicioInstalacao ? styles.campoComValorErrado : ""}`} />
                      <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                        {InputProps?.endAdornment}
                      </span>
                    </>
                  )}
                />
              </LocalizationProvider>
            )}
          />
          {errors?.DataInicioInstalacao && (
            <HelperText text={errors?.DataInicioInstalacao?.message} />
          )}
        </FormControl>

        <FormControl variant="outlined" style={{ marginTop: "20px", marginLeft: "60px" }} className={styles['campos-p']}>
          <InputLabel shrink style={{ color: "#B8B8B8" }} >
            Data término instalação
          </InputLabel>
          <Controller
            name="DataTerminoInstalacao"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                <DatePicker
                  fullWidth
                  inputFormat="dd/MM/yyyy"
                  {...field}
                  disabled={editavelSituacao}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <>
                      <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#fff" }} className={`${errors?.DataTerminoInstalacao ? styles.campoComValorErrado : ""}`} />
                      <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                        {InputProps?.endAdornment}
                      </span>
                    </>
                  )}
                />
              </LocalizationProvider>
            )}
          />
          {errors?.DataTerminoInstalacao && (
            <HelperText text={errors?.DataTerminoInstalacao?.message} />
          )}
        </FormControl>

        <Controller
          name="Observacao"
          control={control}
          render={({ field }) => (
            <FormControl variant="outlined" style={{ marginTop: "20px", marginLeft: "60px" }} className={styles['campos-g']}>
              <InputLabel htmlFor="fiscalizacao-observacoes" shrink sx={{ color: "#B8B8B8" }}>Observações</InputLabel>
              <WhiteInput
                fullWidth
                placeholder="Observações"
                id="fiscalizacao-observacoes"
                name="Observacao"
                minRows={6}
                maxRows={6}
                multiline
                {...field}
                disabled={editavelSituacao}
                className={`${errors?.Observacao ? styles.campoComValorErradoTextArea : ""}`}
              />
              {errors?.Observacao && (
                <HelperText text={errors?.Observacao?.message} />
              )}
            </FormControl>
          )}
        />
      </div>
    </div>
  )
}

export { Geral }